















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import {IAuthData} from "@/model/IAuthData";

  @Component
  export default class UserInfo extends Vue {
    @Prop() private authData!: IAuthData;
    @Prop() private hideFio!: boolean;
    shortFio = '';
    fio = '';

    @Watch('authData')
    onAuthDataChange(newAuthData: IAuthData) {
      this.prepareData(newAuthData);
    }

    created() {
      this.prepareData();
    }

    prepareData(authData: IAuthData = this.authData) {
      if ( !this.authData ) return;

      let fio = '';
      let shortFio = '';

      const name = this.authData.name ? this.authData.name : this.authData.sub;
      const split = name.split(' ');

      if (split.length === 0)
        return;
      else if (split.length === 1) {
        fio = split[0];
        shortFio = split[0].charAt(0);
      }
      else {
        if (split.length >= 3)
          fio = `${split[0]} ${split[1].charAt(0)}.${split[2].charAt(0)}.`;
        else
          fio = `${split[0]} ${split[1].charAt(0)}.`;

        shortFio = `${split[0].charAt(0)}${split[1].charAt(0)}`;
      }

      this.fio = fio;
      this.shortFio = shortFio;
    }
  }
